import Vue from 'vue'
import VueI18n from 'vue-i18n'
///import store from '@/store/index.js'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: /*store.getters.getLanguage ||*/ 'en',
  fallbackLocale: 'en',
  messages: {
    'ar': require('../lang/ar.json'),
    'bs': require('../lang/bs.json'),
    'de': require('../lang/de.json'),
    'en': require('../lang/en.json'),
    'es': require('../lang/es.json'),
    'fr': require('../lang/fr.json'),
    'hi': require('../lang/hi.json'),
    'hr': require('../lang/hr.json'),
    'it': require('../lang/it.json'),
    'ja': require('../lang/ja.json'),
    'pt': require('../lang/pt.json'),
    'ru': require('../lang/ru.json'),
    'tr': require('../lang/tr.json'),
    'uk': require('../lang/uk.json'),
    'zh-cn': require('../lang/zh-CN.json'),
    'zh-tw': require('../lang/zh-TW.json')
  }
})
